import { formatPct } from "../../formatters"
import { format, ISoilUnitConfig, soilColors } from "../../omnia"
import { LayerTypeId } from "../../types"
import { EcScanViewer } from "./ecscan"
import { PcnViewer } from "./pcn"
import { SoilAnalysisViewer } from "./soil"
import { TerraMapViewer } from "./terramap"

const getColors = soilColors.getSoilColors

export function getSoilMapViewers(units: ISoilUnitConfig) {

    return [].concat(

        ["P2O5", "K2O", "MgO", "CaO", "SO3"].map(c => {

            return SoilAnalysisViewer.getFactory(c, () => units.soil, { name: format.formatChemicalCompoundNameAsUnicode(c), colors: getColors(c) })

        }),

        SoilAnalysisViewer.getFactory("WaterpH", null, { name: "pH", colors: getColors("pH") }),

        ["P2O5", "K2O", "MgO", "CaO", "SO3", "Na"].map(c => {
            const propertyName = `Available${c}`
            const cc = getColors(`Available${c}`)
            return SoilAnalysisViewer.getFactory(propertyName, "kg/ha", { name: "Available " + format.formatChemicalCompoundNameAsUnicode(c), colors: cc });
        }),

        ["P2O5", "K2O", "MgO", "CaO", "SO3", "Na"].map(c => {
            const propertyName = `Total${c}`
            const cc = getColors(`Available${c}`)
            return SoilAnalysisViewer.getFactory(propertyName, "kg/ha", { name: "Total " + format.formatChemicalCompoundNameAsUnicode(c), colors: cc });
        }),

        SoilAnalysisViewer.getFactory("OrganicMatter", "%", {
            name: "Organic matter",
            formatter: (value => formatPct(value, 1)),
            colors: getColors("OrganicMatter")
        }),

        SoilAnalysisViewer.getFactory("OrganicMatterLoi", "%", {
            name: "Organic matter (Loi)",
            formatter: (value => formatPct(value, 1)),
            colors: getColors("OrganicMatter"),
        }),

        SoilAnalysisViewer.getFactory("SoilCEC", "meq/100g", { name: "C.E.C" }),

        ["Sand", "Silt", "Clay"].map(c => SoilAnalysisViewer.getFactory(c, "%", { colors: getColors("SoilTexture") })),

        ["Boron", "Copper", "Iron", "Molybdenum", "Sodium", "Zinc"].map(c =>
            SoilAnalysisViewer.getFactory(c, "ppm")
        ),

        EcScanViewer.getFactory(),

        PcnViewer.getFactory("Cysts per 100 gram", "CystsPer100Gram"),

        PcnViewer.getFactory("Eggs per gram", "EggsPerGram"),

        [LayerTypeId.P2O5, LayerTypeId.K2O, LayerTypeId.MgO].map(t => TerraMapViewer.getFactory(t, () => units.soil))

    )

}
